export default __webpack_public_path__ + "static/media/t3.c2dfc343.jpeg";